@if (feedbackQuestions) {
  <h3 translate class="title px-5 py-1">Users Feedback </h3>
  @for (question of feedbackQuestions; track question) {
    <div
      class="list-question">
      <div >
        @switch (question.name) {
          @case ('Text') {
            <div class="my-4">
              <list-text-gadget [data]="question['statistics_info']?.statistics" [title]="question['alias']" [dataCount]="question['statistics_info']?.row_count"></list-text-gadget>
            </div>
          }
          @case ('Yes/No') {
            <div class="my-4">
              <progress-gadget [data]="question" [title]="question['alias']" [dataCount]="question['statistics_info']?.row_count"></progress-gadget>
            </div>
          }
          @case ('Select') {
            <div class="my-4">
              <multiple-bars-gadget [data]="question" [title]="question['alias']" [dataCount]="question['statistics_info']?.row_count" ></multiple-bars-gadget>
            </div>
          }
        }
      </div>
    </div>
  }
}
